import { render, staticRenderFns } from "./content-with-image-and-links.vue?vue&type=template&id=44ffb496&scoped=true&"
import script from "./content-with-image-and-links.vue?vue&type=script&lang=js&"
export * from "./content-with-image-and-links.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=44ffb496&scoped=true&lang=css&"
import style1 from "./content-with-image-and-links.vue?vue&type=style&index=1&id=44ffb496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ffb496",
  null
  
)

export default component.exports